
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d6Ahp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $ljQiY = parcelRequire("ljQiY");


var $GgjDt = parcelRequire("GgjDt");


const $b1fbd1cdbf216579$var$CursorIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b1Pb5",
    name: "CursorIcon",
    loader: async ()=>(await (parcelRequire("5cJDB"))).CursorIcon
});

const $b1fbd1cdbf216579$var$CursorPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d5MrK",
    name: "CursorPresenceIcon",
    loader: async ()=>(await (parcelRequire("3Kj88"))).CursorPresenceIcon
});

const $b1fbd1cdbf216579$var$ExternalPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5eua7",
    name: "ExternalPresenceIcon",
    loader: async ()=>(await (parcelRequire("cRqOx"))).ExternalPresenceIcon
});

const $b1fbd1cdbf216579$var$CanvaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ggvDj",
    name: "CanvaPresenceIcon",
    loader: async ()=>(await (parcelRequire("axrZ5"))).CanvaPresenceIcon
}); /**
     * The Claude, ChatGPT and Figma brand icons only render for the rare
     * `agentIcon === 'claude'` / `'chatgpt'` / `'figma'` cases, so — like the Cursor icon —
     * they are code-split into their own chunks and loaded after paint rather than weighing
     * down every chunk that includes this module.
     */ 

const $b1fbd1cdbf216579$var$ClaudeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dxvVm",
    name: "ClaudeIcon",
    loader: async ()=>(await (parcelRequire("azBJu"))).ClaudeIcon
}); /**
     * Presence tiles render inside LazyAnalyticsDialog (LAZY). LoadablePaint here
     * crashes the byline dialog: "ClaudePresenceIcon [PAINT] has a higher priority
     * of it's parent component LazyAnalyticsDialog[LAZY]". Match Figma/Lovable and
     * load after paint.
     */ 

const $b1fbd1cdbf216579$var$ClaudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GVMA6",
    name: "ClaudePresenceIcon",
    loader: async ()=>(await (parcelRequire("hUBX0"))).ClaudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EXw4a",
    name: "ChatGptIcon",
    loader: async ()=>(await (parcelRequire("e3UW8"))).ChatGptIcon
});

const $b1fbd1cdbf216579$var$FigmaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcBW4",
    name: "FigmaPresenceIcon",
    loader: async ()=>(await (parcelRequire("iisvf"))).FigmaPresenceIcon
});

const $b1fbd1cdbf216579$var$LovablePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hiKXZ",
    name: "LovablePresenceIcon",
    loader: async ()=>(await (parcelRequire("c1en2"))).LovablePresenceIcon
});

const $b1fbd1cdbf216579$var$ReplitPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BdY0I",
    name: "ReplitPresenceIcon",
    loader: async ()=>(await (parcelRequire("acPvf"))).ReplitPresenceIcon
}); /**
     * The Dia and Codex icons only render for the rare `agentIcon === 'dia'` / `'codex'`
     * cases, so — like the other brand icons — they are code-split into their own chunks and
     * loaded after paint.
     */ 

const $b1fbd1cdbf216579$var$DiaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "00DEF",
    name: "DiaIcon",
    loader: async ()=>(await (parcelRequire("4U3Dw"))).DiaIcon
});

const $b1fbd1cdbf216579$var$CodexIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "UYqXM",
    name: "CodexIcon",
    loader: async ()=>(await (parcelRequire("1IFox"))).CodexIcon
});

const $b1fbd1cdbf216579$var$CodexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "stDdE",
    name: "CodexPresenceIcon",
    loader: async ()=>(await (parcelRequire("4EBC2"))).CodexPresenceIcon
});

const $b1fbd1cdbf216579$var$RovoPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "i0C6G",
    name: "RovoPresenceIcon",
    loader: async ()=>(await (parcelRequire("04yz9"))).RovoPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rHk7j",
    name: "GrokIcon",
    loader: async ()=>(await (parcelRequire("4bG1w"))).GrokIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dP-Du",
    name: "GitHubCopilotIcon",
    loader: async ()=>(await (parcelRequire("SbELt"))).GitHubCopilotIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Nlex7",
    name: "VisualStudioCodeIcon",
    loader: async ()=>(await (parcelRequire("5yNuQ"))).VisualStudioCodeIcon
});

const $b1fbd1cdbf216579$var$OpenCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IBz4P",
    name: "OpenCodeIcon",
    loader: async ()=>(await (parcelRequire("dPVqa"))).OpenCodeIcon
});

const $b1fbd1cdbf216579$var$HermesAgentIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ygIH0",
    name: "HermesAgentIcon",
    loader: async ()=>(await (parcelRequire("jXHfv"))).HermesAgentIcon
});

const $b1fbd1cdbf216579$var$KiroIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GmIrZ",
    name: "KiroIcon",
    loader: async ()=>(await (parcelRequire("lQMhC"))).KiroIcon
});

const $b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RlN7s",
    name: "FirstPartyAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("5hHPF"))).FirstPartyAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$AmplitudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erxfS",
    name: "AmplitudePresenceIcon",
    loader: async ()=>(await (parcelRequire("detRP"))).AmplitudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5Sn5H",
    name: "ChatGptPresenceIcon",
    loader: async ()=>(await (parcelRequire("hUKow"))).ChatGptPresenceIcon
});

const $b1fbd1cdbf216579$var$CortexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "aKhvU",
    name: "CortexPresenceIcon",
    loader: async ()=>(await (parcelRequire("ksUc9"))).CortexPresenceIcon
});

const $b1fbd1cdbf216579$var$DatabricksPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "56vYg",
    name: "DatabricksPresenceIcon",
    loader: async ()=>(await (parcelRequire("1ymsJ"))).DatabricksPresenceIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zvpYp",
    name: "GitHubCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("l02sw"))).GitHubCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$ManusPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NPozu",
    name: "ManusPresenceIcon",
    loader: async ()=>(await (parcelRequire("dJURp"))).ManusPresenceIcon
});

const $b1fbd1cdbf216579$var$OpenAiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "E8yL1",
    name: "OpenAiPresenceIcon",
    loader: async ()=>(await (parcelRequire("cn2Sm"))).OpenAiPresenceIcon
});

const $b1fbd1cdbf216579$var$SlackPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "shcwR",
    name: "SlackPresenceIcon",
    loader: async ()=>(await (parcelRequire("1Z3b3"))).SlackPresenceIcon
});

const $b1fbd1cdbf216579$var$AntigravityPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAuKS",
    name: "AntigravityPresenceIcon",
    loader: async ()=>(await (parcelRequire("9AvHs"))).AntigravityPresenceIcon
});

const $b1fbd1cdbf216579$var$DiaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "khAwZ",
    name: "DiaPresenceIcon",
    loader: async ()=>(await (parcelRequire("ledxA"))).DiaPresenceIcon
});

const $b1fbd1cdbf216579$var$GeminiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M9R0Y",
    name: "GeminiPresenceIcon",
    loader: async ()=>(await (parcelRequire("hPYjR"))).GeminiPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3EC9u",
    name: "GrokPresenceIcon",
    loader: async ()=>(await (parcelRequire("l4BGG"))).GrokPresenceIcon
});

const $b1fbd1cdbf216579$var$HermesAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bHfrR",
    name: "HermesAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("2xQnO"))).HermesAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$KiroPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g9WFV",
    name: "KiroPresenceIcon",
    loader: async ()=>(await (parcelRequire("jAGuJ"))).KiroPresenceIcon
});

const $b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fPa7_",
    name: "MicrosoftCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("4PkVb"))).MicrosoftCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q1mvx",
    name: "VisualStudioCodePresenceIcon",
    loader: async ()=>(await (parcelRequire("8xU4s"))).VisualStudioCodePresenceIcon
});
const $b1fbd1cdbf216579$var$unidentifiedAgentAvatarBackgroundStyles = null;
const $b1fbd1cdbf216579$var$AGENT_AVATAR_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)';
const $b1fbd1cdbf216579$var$styles = {
    xxsmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC",
    compactInlineSpacing: "_0GTcwRFQfX _2xTnZxFQfX",
    small: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX",
    medium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    iconWrapperSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    iconWrapperMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC",
    unidentifiedAgentAvatarSmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarMedium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _1uo2ZfTcEg",
    unidentifiedAgentAvatarMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1uo2ZfTcEg",
    brandAgentTile: "_1uo2ZfTcEg _0KLXruDMqu",
    accountAvatarTile: "_1uo2ZfTcEg",
    accountAvatarSurface: "_0KLXrulfZc",
    profileClickableAccountAvatar: "_1VJPcaV97n _0yKXXaDIqT",
    profileClickableAccountAvatarTile: "_1VJPca3VxJ _0yKXXaDIqT",
    presenceGlyphTile: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ",
    avatarOffsetInlineStart: "_1VJPcac8DQ"
};
const $b1fbd1cdbf216579$var$AgentAvatarContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== children || $[3] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t2
            }, children);
            $[2] = children;
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t1;
        if ($[5] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.medium
            }, children);
            $[5] = children;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    if (avatarSize === "medium") {
        let t1;
        if ($[7] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
            }, children);
            $[7] = children;
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    if (hasInlineSpacing) {
        let t1;
        if ($[9] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.small
            }, children);
            $[9] = children;
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
    let t1;
    if ($[11] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
        }, children);
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children })=>{
    if (avatarSize === 'xxsmall') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, children);
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.medium
    }, children);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
    }, children);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.small
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
    }, children);
};
const $b1fbd1cdbf216579$var$UnidentifiedAgentAvatar = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: t2
            }, t3);
            $[3] = t2;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2yBoao1qiM"
        ]);
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== avatarSize) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: avatarSize
        });
        $[6] = avatarSize;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "unidentified-agent-avatar-background",
            className: t1
        }, t2);
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const icon = t3;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t4;
        if ($[11] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
            }, icon);
            $[11] = icon;
            $[12] = t4;
        } else t4 = $[12];
        return t4;
    }
    if (avatarSize === "medium") {
        let t4;
        if ($[13] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
            }, icon);
            $[13] = icon;
            $[14] = t4;
        } else t4 = $[14];
        return t4;
    }
    if (hasInlineSpacing) {
        let t4;
        if ($[15] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
            }, icon);
            $[15] = icon;
            $[16] = t4;
        } else t4 = $[16];
        return t4;
    }
    let t4;
    if ($[17] !== icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "unidentified-agent-avatar",
            xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
        }, icon);
        $[17] = icon;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing })=>{
    if (avatarSize === 'xxsmall') // IconTile starts at 20px; compose the compact 16px hexagon with the native small icon.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "unidentified-agent-avatar-background",
        className: (0, $hekY6.default)([
            "_2yBoao1qiM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        label: "",
        appearance: "gray",
        size: avatarSize
    }));
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
    }, icon);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
    }, icon);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
    }, icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
    }, icon);
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise an ADS Avatar in a hexagon. The
    * feature gate keeps the deprecated AgentAvatar as the fallback during rollout.
    */ 
const $b1fbd1cdbf216579$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(297);
    const { name: name, agentIcon: agentIcon, borderColor: t1, avatarUrl: avatarUrl, avatarSize: t2, markSize: markSize, isOffsetInlineStart: t3, hasInlineSpacing: t4, fillProfileClickableFrame: t5, colorMode: t6, usePresenceArtwork: t7, presenceTileFill: presenceTileFill, presenceOutline: presenceOutline } = t0;
    const borderColor = t1 === undefined ? (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false) ? "var(--ds-surface, #FFFFFF)" : undefined : t1;
    const avatarSize = t2 === undefined ? "small" : t2;
    const isOffsetInlineStart = t3 === undefined ? false : t3;
    const hasInlineSpacing = t4 === undefined ? true : t4;
    const fillProfileClickableFrame = t5 === undefined ? false : t5;
    const colorMode = t6 === undefined ? "light" : t6;
    const usePresenceArtwork = t7 === undefined ? false : t7;
    const presenceArtworkEnabled = usePresenceArtwork || (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false);
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            xxsmall: 16,
            small: 24,
            medium: 32
        };
        $[0] = t8;
    } else t8 = $[0];
    const iconSize = t8[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    let t9;
    if ($[1] !== fillProfileClickableFrame) {
        t9 = fillProfileClickableFrame && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false);
        $[1] = fillProfileClickableFrame;
        $[2] = t9;
    } else t9 = $[2];
    const shouldFillProfileClickableFrame = t9;
    let t10;
    if ($[3] !== avatarSize || $[4] !== hasInlineSpacing || $[5] !== presenceOutline) {
        t10 = (icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
                testId: "presence-brand-tile"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $GgjDt.PresenceHexOutlineContext).Provider, {
                value: presenceOutline
            }, icon)));
        $[3] = avatarSize;
        $[4] = hasInlineSpacing;
        $[5] = presenceOutline;
        $[6] = t10;
    } else t10 = $[6];
    const presenceTile = t10;
    let t11;
    bb0: {
        if (agentIcon === "ai-agent" && presenceArtworkEnabled) {
            let t12;
            if ($[7] !== borderColor || $[8] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[7] = borderColor;
                $[8] = iconSize;
                $[9] = t12;
            } else t12 = $[9];
            let t13;
            if ($[10] !== presenceTile || $[11] !== t12) {
                t13 = presenceTile(t12);
                $[10] = presenceTile;
                $[11] = t12;
                $[12] = t13;
            } else t13 = $[12];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "ai-agent") {
            let t12;
            if ($[13] !== avatarSize || $[14] !== hasInlineSpacing) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                });
                $[13] = avatarSize;
                $[14] = hasInlineSpacing;
                $[15] = t12;
            } else t12 = $[15];
            t11 = t12;
            break bb0;
        }
        if (agentIcon === "rovo" && presenceArtworkEnabled) {
            let t12;
            if ($[16] !== borderColor || $[17] !== colorMode || $[18] !== iconSize || $[19] !== presenceTileFill) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[16] = borderColor;
                $[17] = colorMode;
                $[18] = iconSize;
                $[19] = presenceTileFill;
                $[20] = t12;
            } else t12 = $[20];
            let t13;
            if ($[21] !== presenceTile || $[22] !== t12) {
                t13 = presenceTile(t12);
                $[21] = presenceTile;
                $[22] = t12;
                $[23] = t13;
            } else t13 = $[23];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "rovo") {
            let t12;
            if ($[24] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljQiY.RovoIcon), {
                    label: "",
                    size: iconMarkSize
                });
                $[24] = iconMarkSize;
                $[25] = t12;
            } else t12 = $[25];
            let t13;
            if ($[26] !== avatarSize || $[27] !== hasInlineSpacing || $[28] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t12);
                $[26] = avatarSize;
                $[27] = hasInlineSpacing;
                $[28] = t12;
                $[29] = t13;
            } else t13 = $[29];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "cursor" && presenceArtworkEnabled) {
            let t12;
            if ($[30] !== borderColor || $[31] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[30] = borderColor;
                $[31] = iconSize;
                $[32] = t12;
            } else t12 = $[32];
            let t13;
            if ($[33] !== presenceTile || $[34] !== t12) {
                t13 = presenceTile(t12);
                $[33] = presenceTile;
                $[34] = t12;
                $[35] = t13;
            } else t13 = $[35];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "cursor") {
            let t12;
            if ($[36] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[36] = iconMarkSize;
                $[37] = t12;
            } else t12 = $[37];
            let t13;
            if ($[38] !== avatarSize || $[39] !== hasInlineSpacing || $[40] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t12);
                $[38] = avatarSize;
                $[39] = hasInlineSpacing;
                $[40] = t12;
                $[41] = t13;
            } else t13 = $[41];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "canva" && presenceArtworkEnabled) {
            let t12;
            if ($[42] !== borderColor || $[43] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[42] = borderColor;
                $[43] = iconSize;
                $[44] = t12;
            } else t12 = $[44];
            let t13;
            if ($[45] !== presenceTile || $[46] !== t12) {
                t13 = presenceTile(t12);
                $[45] = presenceTile;
                $[46] = t12;
                $[47] = t13;
            } else t13 = $[47];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "claude" && presenceArtworkEnabled) {
            let t12;
            if ($[48] !== borderColor || $[49] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[48] = borderColor;
                $[49] = iconSize;
                $[50] = t12;
            } else t12 = $[50];
            let t13;
            if ($[51] !== presenceTile || $[52] !== t12) {
                t13 = presenceTile(t12);
                $[51] = presenceTile;
                $[52] = t12;
                $[53] = t13;
            } else t13 = $[53];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "claude") {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[54] !== t12 || $[55] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13);
                $[54] = t12;
                $[55] = t13;
                $[56] = t14;
            } else t14 = $[56];
            let t15;
            if ($[57] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[57] = iconMarkSize;
                $[58] = t15;
            } else t15 = $[58];
            let t16;
            if ($[59] !== t14 || $[60] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[59] = t14;
                $[60] = t15;
                $[61] = t16;
            } else t16 = $[61];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "chatgpt" && presenceArtworkEnabled) {
            let t12;
            if ($[62] !== borderColor || $[63] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[62] = borderColor;
                $[63] = iconSize;
                $[64] = t12;
            } else t12 = $[64];
            let t13;
            if ($[65] !== presenceTile || $[66] !== t12) {
                t13 = presenceTile(t12);
                $[65] = presenceTile;
                $[66] = t12;
                $[67] = t13;
            } else t13 = $[67];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "antigravity" && presenceArtworkEnabled) {
            let t12;
            if ($[68] !== borderColor || $[69] !== iconSize || $[70] !== presenceTileFill) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[68] = borderColor;
                $[69] = iconSize;
                $[70] = presenceTileFill;
                $[71] = t12;
            } else t12 = $[71];
            let t13;
            if ($[72] !== presenceTile || $[73] !== t12) {
                t13 = presenceTile(t12);
                $[72] = presenceTile;
                $[73] = t12;
                $[74] = t13;
            } else t13 = $[74];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "dia" && presenceArtworkEnabled) {
            let t12;
            if ($[75] !== borderColor || $[76] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[75] = borderColor;
                $[76] = iconSize;
                $[77] = t12;
            } else t12 = $[77];
            let t13;
            if ($[78] !== presenceTile || $[79] !== t12) {
                t13 = presenceTile(t12);
                $[78] = presenceTile;
                $[79] = t12;
                $[80] = t13;
            } else t13 = $[80];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "gemini" && presenceArtworkEnabled) {
            let t12;
            if ($[81] !== borderColor || $[82] !== iconSize || $[83] !== presenceTileFill) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[81] = borderColor;
                $[82] = iconSize;
                $[83] = presenceTileFill;
                $[84] = t12;
            } else t12 = $[84];
            let t13;
            if ($[85] !== presenceTile || $[86] !== t12) {
                t13 = presenceTile(t12);
                $[85] = presenceTile;
                $[86] = t12;
                $[87] = t13;
            } else t13 = $[87];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "grok" && presenceArtworkEnabled) {
            let t12;
            if ($[88] !== borderColor || $[89] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[88] = borderColor;
                $[89] = iconSize;
                $[90] = t12;
            } else t12 = $[90];
            let t13;
            if ($[91] !== presenceTile || $[92] !== t12) {
                t13 = presenceTile(t12);
                $[91] = presenceTile;
                $[92] = t12;
                $[93] = t13;
            } else t13 = $[93];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "hermes" && presenceArtworkEnabled) {
            let t12;
            if ($[94] !== borderColor || $[95] !== iconSize || $[96] !== presenceTileFill) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[94] = borderColor;
                $[95] = iconSize;
                $[96] = presenceTileFill;
                $[97] = t12;
            } else t12 = $[97];
            let t13;
            if ($[98] !== presenceTile || $[99] !== t12) {
                t13 = presenceTile(t12);
                $[98] = presenceTile;
                $[99] = t12;
                $[100] = t13;
            } else t13 = $[100];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "kiro" && presenceArtworkEnabled) {
            let t12;
            if ($[101] !== borderColor || $[102] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[101] = borderColor;
                $[102] = iconSize;
                $[103] = t12;
            } else t12 = $[103];
            let t13;
            if ($[104] !== presenceTile || $[105] !== t12) {
                t13 = presenceTile(t12);
                $[104] = presenceTile;
                $[105] = t12;
                $[106] = t13;
            } else t13 = $[106];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "microsoft-copilot" && presenceArtworkEnabled) {
            let t12;
            if ($[107] !== borderColor || $[108] !== iconSize || $[109] !== presenceTileFill) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[107] = borderColor;
                $[108] = iconSize;
                $[109] = presenceTileFill;
                $[110] = t12;
            } else t12 = $[110];
            let t13;
            if ($[111] !== presenceTile || $[112] !== t12) {
                t13 = presenceTile(t12);
                $[111] = presenceTile;
                $[112] = t12;
                $[113] = t13;
            } else t13 = $[113];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "vscode" && presenceArtworkEnabled) {
            let t12;
            if ($[114] !== borderColor || $[115] !== iconSize || $[116] !== presenceTileFill) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[114] = borderColor;
                $[115] = iconSize;
                $[116] = presenceTileFill;
                $[117] = t12;
            } else t12 = $[117];
            let t13;
            if ($[118] !== presenceTile || $[119] !== t12) {
                t13 = presenceTile(t12);
                $[118] = presenceTile;
                $[119] = t12;
                $[120] = t13;
            } else t13 = $[120];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "chatgpt") {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[121] !== t12 || $[122] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13);
                $[121] = t12;
                $[122] = t13;
                $[123] = t14;
            } else t14 = $[123];
            let t15;
            if ($[124] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[124] = iconMarkSize;
                $[125] = t15;
            } else t15 = $[125];
            let t16;
            if ($[126] !== t14 || $[127] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[126] = t14;
                $[127] = t15;
                $[128] = t16;
            } else t16 = $[128];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "figma" && presenceArtworkEnabled) {
            let t12;
            if ($[129] !== borderColor || $[130] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[129] = borderColor;
                $[130] = iconSize;
                $[131] = t12;
            } else t12 = $[131];
            let t13;
            if ($[132] !== presenceTile || $[133] !== t12) {
                t13 = presenceTile(t12);
                $[132] = presenceTile;
                $[133] = t12;
                $[134] = t13;
            } else t13 = $[134];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "lovable" && presenceArtworkEnabled) {
            let t12;
            if ($[135] !== borderColor || $[136] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[135] = borderColor;
                $[136] = iconSize;
                $[137] = t12;
            } else t12 = $[137];
            let t13;
            if ($[138] !== presenceTile || $[139] !== t12) {
                t13 = presenceTile(t12);
                $[138] = presenceTile;
                $[139] = t12;
                $[140] = t13;
            } else t13 = $[140];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "replit" && presenceArtworkEnabled) {
            let t12;
            if ($[141] !== borderColor || $[142] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[141] = borderColor;
                $[142] = iconSize;
                $[143] = t12;
            } else t12 = $[143];
            let t13;
            if ($[144] !== presenceTile || $[145] !== t12) {
                t13 = presenceTile(t12);
                $[144] = presenceTile;
                $[145] = t12;
                $[146] = t13;
            } else t13 = $[146];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "dia") {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[147] !== t12 || $[148] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[147] = t12;
                $[148] = t13;
                $[149] = t14;
            } else t14 = $[149];
            let t15;
            if ($[150] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[150] = iconMarkSize;
                $[151] = t15;
            } else t15 = $[151];
            let t16;
            if ($[152] !== t14 || $[153] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[152] = t14;
                $[153] = t15;
                $[154] = t16;
            } else t16 = $[154];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "codex" && presenceArtworkEnabled) {
            let t12;
            if ($[155] !== borderColor || $[156] !== colorMode || $[157] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor
                });
                $[155] = borderColor;
                $[156] = colorMode;
                $[157] = iconSize;
                $[158] = t12;
            } else t12 = $[158];
            let t13;
            if ($[159] !== presenceTile || $[160] !== t12) {
                t13 = presenceTile(t12);
                $[159] = presenceTile;
                $[160] = t12;
                $[161] = t13;
            } else t13 = $[161];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "first-party" && presenceArtworkEnabled) {
            let t12;
            if ($[162] !== borderColor || $[163] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[162] = borderColor;
                $[163] = iconSize;
                $[164] = t12;
            } else t12 = $[164];
            let t13;
            if ($[165] !== presenceTile || $[166] !== t12) {
                t13 = presenceTile(t12);
                $[165] = presenceTile;
                $[166] = t12;
                $[167] = t13;
            } else t13 = $[167];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "amplitude" && presenceArtworkEnabled) {
            let t12;
            if ($[168] !== borderColor || $[169] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[168] = borderColor;
                $[169] = iconSize;
                $[170] = t12;
            } else t12 = $[170];
            let t13;
            if ($[171] !== presenceTile || $[172] !== t12) {
                t13 = presenceTile(t12);
                $[171] = presenceTile;
                $[172] = t12;
                $[173] = t13;
            } else t13 = $[173];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "cortex" && presenceArtworkEnabled) {
            let t12;
            if ($[174] !== borderColor || $[175] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[174] = borderColor;
                $[175] = iconSize;
                $[176] = t12;
            } else t12 = $[176];
            let t13;
            if ($[177] !== presenceTile || $[178] !== t12) {
                t13 = presenceTile(t12);
                $[177] = presenceTile;
                $[178] = t12;
                $[179] = t13;
            } else t13 = $[179];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "databricks" && presenceArtworkEnabled) {
            let t12;
            if ($[180] !== borderColor || $[181] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[180] = borderColor;
                $[181] = iconSize;
                $[182] = t12;
            } else t12 = $[182];
            let t13;
            if ($[183] !== presenceTile || $[184] !== t12) {
                t13 = presenceTile(t12);
                $[183] = presenceTile;
                $[184] = t12;
                $[185] = t13;
            } else t13 = $[185];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "github-copilot" && presenceArtworkEnabled) {
            let t12;
            if ($[186] !== borderColor || $[187] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[186] = borderColor;
                $[187] = iconSize;
                $[188] = t12;
            } else t12 = $[188];
            let t13;
            if ($[189] !== presenceTile || $[190] !== t12) {
                t13 = presenceTile(t12);
                $[189] = presenceTile;
                $[190] = t12;
                $[191] = t13;
            } else t13 = $[191];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "manus" && presenceArtworkEnabled) {
            let t12;
            if ($[192] !== borderColor || $[193] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[192] = borderColor;
                $[193] = iconSize;
                $[194] = t12;
            } else t12 = $[194];
            let t13;
            if ($[195] !== presenceTile || $[196] !== t12) {
                t13 = presenceTile(t12);
                $[195] = presenceTile;
                $[196] = t12;
                $[197] = t13;
            } else t13 = $[197];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "openai" && presenceArtworkEnabled) {
            let t12;
            if ($[198] !== borderColor || $[199] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[198] = borderColor;
                $[199] = iconSize;
                $[200] = t12;
            } else t12 = $[200];
            let t13;
            if ($[201] !== presenceTile || $[202] !== t12) {
                t13 = presenceTile(t12);
                $[201] = presenceTile;
                $[202] = t12;
                $[203] = t13;
            } else t13 = $[203];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "slack" && presenceArtworkEnabled) {
            let t12;
            if ($[204] !== borderColor || $[205] !== iconSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[204] = borderColor;
                $[205] = iconSize;
                $[206] = t12;
            } else t12 = $[206];
            let t13;
            if ($[207] !== presenceTile || $[208] !== t12) {
                t13 = presenceTile(t12);
                $[207] = presenceTile;
                $[208] = t12;
                $[209] = t13;
            } else t13 = $[209];
            t11 = t13;
            break bb0;
        }
        if (agentIcon === "codex") {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[210] !== t12 || $[211] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[210] = t12;
                $[211] = t13;
                $[212] = t14;
            } else t14 = $[212];
            let t15;
            if ($[213] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[213] = iconMarkSize;
                $[214] = t15;
            } else t15 = $[214];
            let t16;
            if ($[215] !== t14 || $[216] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[215] = t14;
                $[216] = t15;
                $[217] = t16;
            } else t16 = $[217];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "grok" && presenceArtworkEnabled) {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[218] !== t12 || $[219] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[218] = t12;
                $[219] = t13;
                $[220] = t14;
            } else t14 = $[220];
            let t15;
            if ($[221] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[221] = iconMarkSize;
                $[222] = t15;
            } else t15 = $[222];
            let t16;
            if ($[223] !== t14 || $[224] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[223] = t14;
                $[224] = t15;
                $[225] = t16;
            } else t16 = $[225];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "github-copilot" && presenceArtworkEnabled) {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[226] !== t12 || $[227] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[226] = t12;
                $[227] = t13;
                $[228] = t14;
            } else t14 = $[228];
            let t15;
            if ($[229] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[229] = iconMarkSize;
                $[230] = t15;
            } else t15 = $[230];
            let t16;
            if ($[231] !== t14 || $[232] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[231] = t14;
                $[232] = t15;
                $[233] = t16;
            } else t16 = $[233];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "vscode" && presenceArtworkEnabled) {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[234] !== t12 || $[235] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[234] = t12;
                $[235] = t13;
                $[236] = t14;
            } else t14 = $[236];
            let t15;
            if ($[237] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[237] = iconMarkSize;
                $[238] = t15;
            } else t15 = $[238];
            let t16;
            if ($[239] !== t14 || $[240] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[239] = t14;
                $[240] = t15;
                $[241] = t16;
            } else t16 = $[241];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "open-code" && presenceArtworkEnabled) {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[242] !== t12 || $[243] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[242] = t12;
                $[243] = t13;
                $[244] = t14;
            } else t14 = $[244];
            let t15;
            if ($[245] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[245] = iconMarkSize;
                $[246] = t15;
            } else t15 = $[246];
            let t16;
            if ($[247] !== t14 || $[248] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[247] = t14;
                $[248] = t15;
                $[249] = t16;
            } else t16 = $[249];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "hermes" && presenceArtworkEnabled) {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[250] !== t12 || $[251] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[250] = t12;
                $[251] = t13;
                $[252] = t14;
            } else t14 = $[252];
            let t15;
            if ($[253] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[253] = iconMarkSize;
                $[254] = t15;
            } else t15 = $[254];
            let t16;
            if ($[255] !== t14 || $[256] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[255] = t14;
                $[256] = t15;
                $[257] = t16;
            } else t16 = $[257];
            t11 = t16;
            break bb0;
        }
        if (agentIcon === "kiro" && presenceArtworkEnabled) {
            const t12 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t13 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t14;
            if ($[258] !== t12 || $[259] !== t13) {
                t14 = (0, $w6R6I.cx)(t12, t13, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[258] = t12;
                $[259] = t13;
                $[260] = t14;
            } else t14 = $[260];
            let t15;
            if ($[261] !== iconMarkSize) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[261] = iconMarkSize;
                $[262] = t15;
            } else t15 = $[262];
            let t16;
            if ($[263] !== t14 || $[264] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t14
                }, t15);
                $[263] = t14;
                $[264] = t15;
                $[265] = t16;
            } else t16 = $[265];
            t11 = t16;
            break bb0;
        }
        let t12;
        if ($[266] !== borderColor) {
            t12 = borderColor === undefined && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false);
            $[266] = borderColor;
            $[267] = t12;
        } else t12 = $[267];
        const hasDefaultAccountAvatarBorder = t12;
        let t13;
        if ($[268] !== avatarSize || $[269] !== avatarUrl || $[270] !== borderColor || $[271] !== hasDefaultAccountAvatarBorder || $[272] !== name) {
            t13 = (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "hexagon",
                src: avatarUrl,
                name: name,
                label: "",
                borderColor: borderColor ?? "var(--ds-surface, #FFFFFF)",
                size: avatarSize
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                size: avatarSize,
                name: name,
                label: "",
                imageUrl: avatarUrl,
                showBorder: borderColor === undefined && !hasDefaultAccountAvatarBorder
            });
            $[268] = avatarSize;
            $[269] = avatarUrl;
            $[270] = borderColor;
            $[271] = hasDefaultAccountAvatarBorder;
            $[272] = name;
            $[273] = t13;
        } else t13 = $[273];
        const accountAvatar = t13;
        let t14;
        if ($[274] !== accountAvatar || $[275] !== shouldFillProfileClickableFrame) {
            t14 = shouldFillProfileClickableFrame ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "profile-clickable-agent-avatar-frame",
                xcss: $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatar
            }, accountAvatar) : accountAvatar;
            $[274] = accountAvatar;
            $[275] = shouldFillProfileClickableFrame;
            $[276] = t14;
        } else t14 = $[276];
        const sizedAccountAvatar = t14;
        if (hasDefaultAccountAvatarBorder) {
            const t15 = shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile;
            let t16;
            if ($[277] !== t15) {
                t16 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, $b1fbd1cdbf216579$var$styles.accountAvatarSurface, t15);
                $[277] = t15;
                $[278] = t16;
            } else t16 = $[278];
            let t17;
            if ($[279] !== sizedAccountAvatar || $[280] !== t16) {
                t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t16
                }, sizedAccountAvatar);
                $[279] = sizedAccountAvatar;
                $[280] = t16;
                $[281] = t17;
            } else t17 = $[281];
            let t18;
            if ($[282] !== avatarSize || $[283] !== hasInlineSpacing || $[284] !== t17) {
                t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t17);
                $[282] = avatarSize;
                $[283] = hasInlineSpacing;
                $[284] = t17;
                $[285] = t18;
            } else t18 = $[285];
            t11 = t18;
            break bb0;
        }
        let t15;
        if ($[286] !== borderColor || $[287] !== shouldFillProfileClickableFrame || $[288] !== sizedAccountAvatar) {
            t15 = borderColor === undefined ? sizedAccountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile),
                style: {
                    backgroundColor: borderColor
                }
            }, sizedAccountAvatar);
            $[286] = borderColor;
            $[287] = shouldFillProfileClickableFrame;
            $[288] = sizedAccountAvatar;
            $[289] = t15;
        } else t15 = $[289];
        let t16;
        if ($[290] !== avatarSize || $[291] !== hasInlineSpacing || $[292] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, t15);
            $[290] = avatarSize;
            $[291] = hasInlineSpacing;
            $[292] = t15;
            $[293] = t16;
        } else t16 = $[293];
        t11 = t16;
    }
    const avatar = t11;
    let t12;
    if ($[294] !== avatar || $[295] !== isOffsetInlineStart) {
        t12 = isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-avatar-offset",
            xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
        }, avatar) : avatar;
        $[294] = avatar;
        $[295] = isOffsetInlineStart;
        $[296] = t12;
    } else t12 = $[296];
    return t12;
} : ({ name: name, agentIcon: agentIcon, borderColor: borderColor = (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false) ? "var(--ds-surface, #FFFFFF)" : undefined, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', markSize: markSize, isOffsetInlineStart: isOffsetInlineStart = false, hasInlineSpacing: hasInlineSpacing = true, fillProfileClickableFrame: fillProfileClickableFrame = false, colorMode: colorMode = 'light', usePresenceArtwork: usePresenceArtwork = false, presenceTileFill: presenceTileFill, presenceOutline: presenceOutline })=>{
    const presenceArtworkEnabled = usePresenceArtwork || (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false);
    const iconSize = {
        xxsmall: 16,
        small: 24,
        medium: 32
    }[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    const shouldFillProfileClickableFrame = fillProfileClickableFrame && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false);
    const presenceTile = (icon)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
            testId: "presence-brand-tile"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $GgjDt.PresenceHexOutlineContext).Provider, {
            value: presenceOutline
        }, icon)));
    };
    const avatar = (()=>{
        if (agentIcon === 'ai-agent' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        });
        if (agentIcon === 'rovo' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljQiY.RovoIcon), {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'cursor' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cursor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'canva' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'chatgpt' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'antigravity' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'dia' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'gemini' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'grok' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'hermes' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'kiro' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'microsoft-copilot' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'vscode' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'chatgpt') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'figma' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'lovable' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'replit' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'dia') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'codex' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor
        }));
        if (agentIcon === 'first-party' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'amplitude' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cortex' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'databricks' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'github-copilot' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'manus' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'openai' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'slack' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'codex') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'grok' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'github-copilot' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'vscode' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'open-code' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'hermes' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'kiro' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
            label: "",
            size: iconMarkSize
        }));
        const hasDefaultAccountAvatarBorder = borderColor === undefined && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false);
        const accountAvatar = (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            src: avatarUrl,
            name: name,
            label: "",
            borderColor: borderColor ?? "var(--ds-surface, #FFFFFF)",
            size: avatarSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            size: avatarSize,
            name: name,
            label: "",
            imageUrl: avatarUrl,
            showBorder: borderColor === undefined && !hasDefaultAccountAvatarBorder
        });
        const sizedAccountAvatar = shouldFillProfileClickableFrame ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "profile-clickable-agent-avatar-frame",
            xcss: $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatar
        }, accountAvatar) : accountAvatar;
        if (hasDefaultAccountAvatarBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, $b1fbd1cdbf216579$var$styles.accountAvatarSurface, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile)
        }, sizedAccountAvatar));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, borderColor === undefined ? sizedAccountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile),
            style: {
                backgroundColor: borderColor
            }
        }, sizedAccountAvatar));
    })();
    return isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-avatar-offset",
        xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
    }, avatar) : avatar;
};
module.exports["AgentRowAvatar"] = $b1fbd1cdbf216579$export$951877a280bbd2e;

});

parcelRegister("ljQiY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d64e44b6455460db$export$e23ae35269442b4f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { label: t1, size: t2 } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? 16 : t2;
    const clipId = (0, $cozmU.useId)();
    const t3 = label ? "img" : "presentation";
    const t4 = label || undefined;
    const t5 = label ? undefined : true;
    const t6 = `url(#${clipId})`;
    let t10;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
            fill: "#1868DB"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
            fill: "#6A9A23"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
            fill: "#AF59E1"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
            fill: "#FCA700"
        });
        $[0] = t10;
        $[1] = t7;
        $[2] = t8;
        $[3] = t9;
    } else {
        t10 = $[0];
        t7 = $[1];
        t8 = $[2];
        t9 = $[3];
    }
    let t11;
    if ($[4] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: t6
        }, t7, t8, t9, t10);
        $[4] = t6;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white"
        });
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== clipId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipId
        }, t12));
        $[7] = clipId;
        $[8] = t13;
    } else t13 = $[8];
    let t14;
    if ($[9] !== size || $[10] !== t11 || $[11] !== t13 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: t3,
            "aria-label": t4,
            "aria-hidden": t5
        }, t11, t13);
        $[9] = size;
        $[10] = t11;
        $[11] = t13;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t14;
    } else t14 = $[15];
    return t14;
} : ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};
module.exports["RovoIcon"] = $d64e44b6455460db$export$e23ae35269442b4f;

});

parcelRegister("GgjDt", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $4b2e5e9c5d38e8f4$export$642f401a307b8452 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4b2e5e9c5d38e8f4$export$685cad5d7f4d1a8c = (0, $3u0dr.isReactCompilerActiveV2)() ? (size)=>{
    const outline = (0, $cozmU.useContext)($4b2e5e9c5d38e8f4$export$642f401a307b8452);
    return outline?.svgHeight ?? size;
} : (size)=>{
    const outline = (0, $cozmU.useContext)($4b2e5e9c5d38e8f4$export$642f401a307b8452);
    return outline?.svgHeight ?? size;
};
const $4b2e5e9c5d38e8f4$export$82f0d998d3955f1f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { d: d, fill: fill, stroke: stroke, strokeWidth: strokeWidth, viewBox: viewBox, size: size } = t0;
    const outline = (0, $cozmU.useContext)($4b2e5e9c5d38e8f4$export$642f401a307b8452);
    if (!outline) {
        let t1;
        if ($[0] !== d || $[1] !== fill || $[2] !== stroke || $[3] !== strokeWidth) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
                d: d,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth
            });
            $[0] = d;
            $[1] = fill;
            $[2] = stroke;
            $[3] = strokeWidth;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    let t1;
    if ($[5] !== viewBox) {
        let t2;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /\s+/;
            $[7] = t2;
        } else t2 = $[7];
        t1 = viewBox.trim().split(t2);
        $[5] = viewBox;
        $[6] = t1;
    } else t1 = $[6];
    const viewBoxWidth = Number(t1[2]);
    let t2;
    if ($[8] !== size || $[9] !== viewBoxWidth) {
        t2 = (cssPixels)=>cssPixels * viewBoxWidth / size;
        $[8] = size;
        $[9] = viewBoxWidth;
        $[10] = t2;
    } else t2 = $[10];
    const toSvgStrokeWidth = t2;
    const centerStrokeWidth = outline.centerStrokeColor ? outline.centerStrokeWidth ?? 0 : 0;
    const backingStrokeWidth = toSvgStrokeWidth(outline.width * 2 + centerStrokeWidth);
    let t3;
    if ($[11] !== backingStrokeWidth || $[12] !== d || $[13] !== stroke) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-presence-layer": "outline",
            d: d,
            fill: stroke,
            stroke: stroke,
            strokeWidth: backingStrokeWidth
        });
        $[11] = backingStrokeWidth;
        $[12] = d;
        $[13] = stroke;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== d || $[16] !== fill) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-presence-layer": "fill",
            d: d,
            fill: fill
        });
        $[15] = d;
        $[16] = fill;
        $[17] = t4;
    } else t4 = $[17];
    let t5;
    if ($[18] !== d || $[19] !== outline.centerStrokeColor || $[20] !== outline.centerStrokeWidth || $[21] !== toSvgStrokeWidth) {
        t5 = outline.centerStrokeColor && outline.centerStrokeWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-presence-layer": "center-stroke",
            d: d,
            fill: "none",
            stroke: outline.centerStrokeColor,
            strokeWidth: toSvgStrokeWidth(outline.centerStrokeWidth)
        }) : null;
        $[18] = d;
        $[19] = outline.centerStrokeColor;
        $[20] = outline.centerStrokeWidth;
        $[21] = toSvgStrokeWidth;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t5);
        $[23] = t3;
        $[24] = t4;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
} : ({ d: d, fill: fill, stroke: stroke, strokeWidth: strokeWidth, viewBox: viewBox, size: size })=>{
    const outline = (0, $cozmU.useContext)($4b2e5e9c5d38e8f4$export$642f401a307b8452);
    if (!outline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    });
    const viewBoxWidth = Number(viewBox.trim().split(/\s+/)[2]);
    const toSvgStrokeWidth = (cssPixels)=>cssPixels * viewBoxWidth / size;
    const centerStrokeWidth = outline.centerStrokeColor ? outline.centerStrokeWidth ?? 0 : 0;
    // Half the backing stroke is covered by the fill; the center stroke covers another half-width.
    const backingStrokeWidth = toSvgStrokeWidth(outline.width * 2 + centerStrokeWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "outline",
        d: d,
        fill: stroke,
        stroke: stroke,
        strokeWidth: backingStrokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "fill",
        d: d,
        fill: fill
    }), outline.centerStrokeColor && outline.centerStrokeWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "center-stroke",
        d: d,
        fill: "none",
        stroke: outline.centerStrokeColor,
        strokeWidth: toSvgStrokeWidth(outline.centerStrokeWidth)
    }) : null);
};
module.exports["PresenceHexOutlineContext"] = $4b2e5e9c5d38e8f4$export$642f401a307b8452;
module.exports["usePresenceSvgHeight"] = $4b2e5e9c5d38e8f4$export$685cad5d7f4d1a8c;
module.exports["PresenceHexArtwork"] = $4b2e5e9c5d38e8f4$export$82f0d998d3955f1f;

});

parcelRegister("5cJDB", function(module, exports) {

let $3ca17975e4f3b4f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ca17975e4f3b4f7$var$load("6ZG8u").then(()=>parcelRequire('6jEu7'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("3Kj88", function(module, exports) {

let $2ba481da298028fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ba481da298028fa$var$load("d078q").then(()=>parcelRequire('hzh0G'));

});

parcelRegister("cRqOx", function(module, exports) {

let $95cf3c01f6a3fbd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95cf3c01f6a3fbd0$var$load("jeBZv").then(()=>parcelRequire('kZomH'));

});

parcelRegister("axrZ5", function(module, exports) {

let $7ac2b187060f556b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ac2b187060f556b$var$load("k6lE4").then(()=>parcelRequire('iSJUf'));

});

parcelRegister("azBJu", function(module, exports) {

let $7b2a71372d458066$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b2a71372d458066$var$load("5glfK").then(()=>parcelRequire('dk4rY'));

});

parcelRegister("hUBX0", function(module, exports) {

let $d0a51adcc339fcf0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0a51adcc339fcf0$var$load("dXdKj").then(()=>parcelRequire('12keR'));

});

parcelRegister("e3UW8", function(module, exports) {

let $a3cd82eeffec6166$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3cd82eeffec6166$var$load("kFqB1").then(()=>parcelRequire('eKYtd'));

});

parcelRegister("iisvf", function(module, exports) {

let $d5200486ac9db51b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5200486ac9db51b$var$load("62AY2").then(()=>parcelRequire('1jkOH'));

});

parcelRegister("c1en2", function(module, exports) {

let $8c00b9b89a2742dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c00b9b89a2742dd$var$load("1NSgm").then(()=>parcelRequire('1TBoE'));

});

parcelRegister("acPvf", function(module, exports) {

let $76e2f9cb783aa055$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76e2f9cb783aa055$var$load("4Rnmf").then(()=>parcelRequire('8k6NU'));

});

parcelRegister("4U3Dw", function(module, exports) {

let $391f367cdb325622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $391f367cdb325622$var$load("biaNf").then(()=>parcelRequire('13BtP'));

});

parcelRegister("1IFox", function(module, exports) {

let $140a02a6f70aa171$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $140a02a6f70aa171$var$load("33mZN").then(()=>parcelRequire('lrXp3'));

});

parcelRegister("4EBC2", function(module, exports) {

let $363812ea8042220c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $363812ea8042220c$var$load("3kcD5").then(()=>parcelRequire('dFAIb'));

});

parcelRegister("04yz9", function(module, exports) {

let $00db2fee4a0dfb1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00db2fee4a0dfb1e$var$load("4um3K").then(()=>parcelRequire('hswbu'));

});

parcelRegister("4bG1w", function(module, exports) {

let $30c8c97bb4b9fd9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30c8c97bb4b9fd9a$var$load("iywqf").then(()=>parcelRequire('8Iy5T'));

});

parcelRegister("SbELt", function(module, exports) {

let $0a2e15ff56984941$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a2e15ff56984941$var$load("c9sWd").then(()=>parcelRequire('fS7L5'));

});

parcelRegister("5yNuQ", function(module, exports) {

let $40c685b0a5c7de7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40c685b0a5c7de7a$var$load("fdu0f").then(()=>parcelRequire('cKQ8f'));

});

parcelRegister("dPVqa", function(module, exports) {

let $a12c946acc0ba5bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a12c946acc0ba5bf$var$load("8u4IE").then(()=>parcelRequire('jYUVi'));

});

parcelRegister("jXHfv", function(module, exports) {

let $e885135e1efd934d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e885135e1efd934d$var$load("dJDoX").then(()=>parcelRequire('bdcWi'));

});

parcelRegister("lQMhC", function(module, exports) {

let $fe83e8532d755559$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe83e8532d755559$var$load("fsgfk").then(()=>parcelRequire('dv9m9'));

});

parcelRegister("5hHPF", function(module, exports) {

let $3d908a7d29adcec1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d908a7d29adcec1$var$load("60Dx4").then(()=>parcelRequire('40zAY'));

});

parcelRegister("detRP", function(module, exports) {

let $9a23c02cee70c20c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a23c02cee70c20c$var$load("gkTi7").then(()=>parcelRequire('bJnCe'));

});

parcelRegister("hUKow", function(module, exports) {

let $d0aba79d0f4e79e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0aba79d0f4e79e9$var$load("bB8Gp").then(()=>parcelRequire('axB4X'));

});

parcelRegister("ksUc9", function(module, exports) {

let $ee620356b3790458$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee620356b3790458$var$load("gByWd").then(()=>parcelRequire('gzCxZ'));

});

parcelRegister("1ymsJ", function(module, exports) {

let $121a63f77b935e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $121a63f77b935e4e$var$load("4yDcQ").then(()=>parcelRequire('j89Z8'));

});

parcelRegister("l02sw", function(module, exports) {

let $f49b815a8f99f793$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f49b815a8f99f793$var$load("cAM1Y").then(()=>parcelRequire('kHAEb'));

});

parcelRegister("dJURp", function(module, exports) {

let $a00b959bf58bcbd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a00b959bf58bcbd0$var$load("lTnC6").then(()=>parcelRequire('ag5rE'));

});

parcelRegister("cn2Sm", function(module, exports) {

let $9019dd12167c670d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9019dd12167c670d$var$load("dxw4H").then(()=>parcelRequire('gPmXi'));

});

parcelRegister("1Z3b3", function(module, exports) {

let $171df3dfdb344bc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $171df3dfdb344bc1$var$load("8reyc").then(()=>parcelRequire('cXUwc'));

});

parcelRegister("9AvHs", function(module, exports) {

let $6fb010c81690ae08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fb010c81690ae08$var$load("bJw8x").then(()=>parcelRequire('fn6zv'));

});

parcelRegister("ledxA", function(module, exports) {

let $f74568ac19ffb44c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f74568ac19ffb44c$var$load("7uGZG").then(()=>parcelRequire('h3Ihr'));

});

parcelRegister("hPYjR", function(module, exports) {

let $cfc5fd3e7b76411d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc5fd3e7b76411d$var$load("dQibE").then(()=>parcelRequire('cy9Hj'));

});

parcelRegister("l4BGG", function(module, exports) {

let $f57734a6cea414ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f57734a6cea414ae$var$load("f8Wnw").then(()=>parcelRequire('cqucg'));

});

parcelRegister("2xQnO", function(module, exports) {

let $1da74c00ddcf2822$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1da74c00ddcf2822$var$load("knn8O").then(()=>parcelRequire('elp5y'));

});

parcelRegister("jAGuJ", function(module, exports) {

let $e43257ada3c8dbb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e43257ada3c8dbb3$var$load("hLnGd").then(()=>parcelRequire('jgCik'));

});

parcelRegister("4PkVb", function(module, exports) {

let $383c27636001b7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $383c27636001b7f1$var$load("9MeFV").then(()=>parcelRequire('gAVq7'));

});

parcelRegister("8xU4s", function(module, exports) {

let $638ce650167e76be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $638ce650167e76be$var$load("5pNPC").then(()=>parcelRequire('7oMQm'));

});

parcelRegister("a4kze", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $6b1a38d2e8ef626f$var$AGENT_BRANDS = [
    {
        name: 'Claude Code',
        agentIcon: 'claude'
    },
    {
        name: 'Claude',
        agentIcon: 'claude'
    },
    {
        name: 'Codex',
        agentIcon: 'codex'
    },
    {
        name: 'Rovo',
        agentIcon: 'rovo'
    },
    {
        name: 'Cursor',
        agentIcon: 'cursor'
    },
    {
        name: 'ChatGPT',
        agentIcon: 'chatgpt'
    },
    {
        name: 'Dia',
        agentIcon: 'dia'
    }
];
const $6b1a38d2e8ef626f$var$PRESENCE_AGENT_BRANDS = [
    {
        name: '1P',
        agentIcon: 'first-party'
    },
    {
        name: '1P Agent',
        agentIcon: 'first-party'
    },
    {
        name: 'Amplitude',
        agentIcon: 'amplitude'
    },
    {
        name: 'Antigravity',
        agentIcon: 'antigravity'
    },
    {
        name: 'Canva',
        agentIcon: 'canva'
    },
    {
        name: 'Cortex',
        agentIcon: 'cortex'
    },
    {
        name: 'Databricks',
        agentIcon: 'databricks'
    },
    {
        name: 'Figma',
        agentIcon: 'figma'
    },
    {
        name: 'Gemini',
        agentIcon: 'gemini'
    },
    {
        name: 'GitHub Copilot',
        agentIcon: 'github-copilot'
    },
    {
        name: 'Grok',
        agentIcon: 'grok'
    },
    {
        name: 'Hermes Agent',
        agentIcon: 'hermes'
    },
    {
        name: 'Kiro',
        agentIcon: 'kiro'
    },
    {
        name: 'Lovable',
        agentIcon: 'lovable'
    },
    {
        name: 'Manus',
        agentIcon: 'manus'
    },
    {
        name: 'Microsoft Copilot',
        agentIcon: 'microsoft-copilot'
    },
    {
        name: 'OpenAI',
        agentIcon: 'openai'
    },
    {
        name: 'Replit',
        agentIcon: 'replit'
    },
    {
        name: 'Slack',
        agentIcon: 'slack'
    },
    {
        name: 'Visual Studio Code',
        agentIcon: 'vscode'
    },
    {
        name: 'VS Code',
        agentIcon: 'vscode'
    }
];
const $6b1a38d2e8ef626f$export$75658d737923c3d1 = (displayName)=>{
    const matches = ({ name: name })=>displayName === name || displayName.startsWith(`${name} (`);
    const brand = $6b1a38d2e8ef626f$var$AGENT_BRANDS.find(matches);
    if (brand) return brand;
    const presenceBrand = $6b1a38d2e8ef626f$var$PRESENCE_AGENT_BRANDS.find(matches);
    if (presenceBrand && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceBrand;
    return undefined;
};
module.exports["getAgentBrand"] = $6b1a38d2e8ef626f$export$75658d737923c3d1;

});

parcelRegister("3EM6l", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $4dbee925501a87b6$export$97ecd45ebbe7353 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return colorMode === "dark" ? "dark" : "light";
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return colorMode === 'dark' ? 'dark' : 'light';
};
module.exports["useAgentAvatarColorMode"] = $4dbee925501a87b6$export$97ecd45ebbe7353;

});


//# sourceMappingURL=CommentsPanelWrapper.ed26e90f.js.map
